<template>
  <div id="app">
    <!--    <div>-->
    <!-- <div v-if="$route.path.includes('enterprise') || $route.path==='/'"> -->
    <div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
    </div>
    <FullTips :show="false"/>
    <!-- </div> -->
    <!-- <div v-else class="tips">敬请期待</div> -->
  </div>
</template>

<script>
import FullTips from "@/components/FullTips.vue";

export default {
  name: 'App',
  components: {FullTips},
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.tips {
  font-size: 20px;
  color: #333;
  text-align: center;
  margin-top: 20px;
}
</style>